import { get, post } from '../../../../util/api'
import * as type from './type'
import * as selector from './selector'

export const findAppointmentRequest = () => ({
    type: type.FIND_APPOINTMENT_REQUEST,
    payload: {},
})

export const findAppointmentSuccess = (appointment) => ({
    type: type.FIND_APPOINTMENT_SUCCESS,
    payload: {
        appointment,
    },
})

export const findAppointmentError = (error) => ({
    type: type.FIND_APPOINTMENT_ERROR,
    payload: {
        error,
    },
})

export const findAppointment = (appointmentId) => (dispatch, getState) => {
    dispatch(findAppointmentRequest())

    get('/api/appointment/find-appointment-by-id?appointmentId=' + appointmentId)
        .then(appointment => {
            dispatch(findAppointmentSuccess(appointment))
        })
        .catch(error => {
            dispatch(findAppointmentError(error))
        })
}

export const changeAppointment = (name, value) => ({
    type: type.CHANGE_APPOINTMENT,
    payload: {
        name,
        value,
    },
})

export const setAppointmentCancelCategoryRequest = () => ({
    type: type.FIND_APPOINTMENT_REQUEST,
    payload: {},
})

export const setAppointmentCancelCategorySuccess = (appointment) => ({
    type: type.FIND_APPOINTMENT_SUCCESS,
    payload: {
        appointment,
    },
})

export const setAppointmentCancelCategoryError = (error) => ({
    type: type.FIND_APPOINTMENT_ERROR,
    payload: {
        error,
    },
})

export const setAppointmentCancelCategory = () => (dispatch, getState) => {
    const state = getState()
    const appointment = selector.selectAppointment(state)

    dispatch(setAppointmentCancelCategoryRequest())

    post('/api/appointment/set-cancel-category', {
        appointmentId: appointment.id,
        cancelCategory: appointment.cancelCategory,
    })
        .then(appointment => {
            dispatch(setAppointmentCancelCategorySuccess(appointment))
        })
        .catch(error => {
            dispatch(setAppointmentCancelCategoryError(error))
        })
}



// WEBPACK FOOTER //
// ./src/modules/appointment/state/detail/action.js